import { Component, Inject } from '@angular/core';
import { ApplicationsService } from '../applications.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { Application } from '../application.model';
import { UIDialogData } from 'app/ui/dialog/dialog-injector';

@Component({
    selector: 'restore-token',
    templateUrl: 'restore-token.component.html',
    styleUrls: ['restore-token.component.scss']
})
export class RestoreTokenComponent {

    isLoading = false;

    constructor(
        @Inject(UIDialogData)
        public application: Application,
        private applicationsServiice: ApplicationsService,
        private dialogService: UIDialogService
    ) {
    }

    async restore() {
        this.isLoading = true;
        try {
            await this.applicationsServiice.restetToken(this.application.id).toPromise();
            this.dialogService.close();
        } catch(error) {
            console.error(error);
            this.isLoading = false;
        }
    }

    cancel() {
        this.dialogService.close();
    }

}